<template>
  <div class="wizard-prog-bar"
    :style="{
      left: `${(1 / (steps.length * 2)) * 100}%`,
      'transition-duration': `${transitionDuration}ms`,
      width: `${width * 100}%`
    }"
  ></div>
</template>

<script>
import { mapInstanceState as mapState } from '@urbn/vuex-helpers';
import { STORE_NAMESPACE_KEY } from './const';
import { ACTIVE_STEP_INDEX, STEPS } from '../../store/modules/formWizard/state';

export default {
  inject: [STORE_NAMESPACE_KEY],

  props: {
    /**
     * Override the status to show that all steps are complete.
     */
    allStepsComplete: Boolean,

    transitionDuration: {
      type: Number,
      default: () => 500
    }
  },

  computed: {
    ...mapState((vm) => vm[STORE_NAMESPACE_KEY], {
      activeStepIndex: ACTIVE_STEP_INDEX,
      steps: STEPS
    }),

    width: ({ activeStepIndex, allStepsComplete, steps }) => (1 / steps.length)
      * (allStepsComplete ? (steps.length - 1) : activeStepIndex)
  },
};
</script>

<style lang="scss" scoped>
.wizard-prog-bar {
  background-color: black;  // Default; override with CSS.
  height: 5px;                // Default; override with CSS.
  position: absolute;
  transition-property: width;

  @media (prefers-reduced-motion: reduce) {
    transition-property: none;
  }
}
</style>
